/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import { showToast } from 'vant';
import DateHeaderWithBtn from './cpns/DateHeaderWithBtn.vue';
import CTypeTabs from './cpns/CTypeTabs.vue';
import ReportForm from './cpns/ReportForm.vue';
import TableForm from './cpns/TableForm.vue';
import { useFeedingHandover, useFeedingPowerOn } from './hooks/useFeedingForm';
import { getTimeRange } from './hooks/time';
export default defineComponent({
  name: 'FeedingForm',
  components: {
    CTypeTabs: CTypeTabs,
    ReportForm: ReportForm,
    TableForm: TableForm,
    DateHeaderWithBtn: DateHeaderWithBtn
  },
  setup: function setup() {
    // 交接班时间
    var _useFeedingHandover = useFeedingHandover(),
      _useFeedingHandover2 = _slicedToArray(_useFeedingHandover, 2),
      handoverData = _useFeedingHandover2[0],
      getFeedingHandoverAsync = _useFeedingHandover2[1];
    var handoverTime = computed(function () {
      return handoverData.value.show_time;
    });
    // 当前日期区间
    var params = ref({
      startTime: "".concat(dayjs().format('YYYY-MM-DD'), " 00:00:00"),
      endTime: "".concat(dayjs().format('YYYY-MM-DD'), " 23:59:59"),
      type: 0
    });
    var tabIndexF = ref(0);
    // 切换图标和表格
    var confirmTypeF = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              tabIndexF.value = val;
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function confirmTypeF(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var tabIndexS = ref(2);
    //  切换交接班 开关机  自然日
    var confirmTypeS = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(val) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              tabIndexS.value = val;
              if (tabIndexS.value === 0) {
                params.value.startTime = handoverData.value.start_time;
                params.value.endTime = handoverData.value.end_time;
              }
              if (tabIndexS.value === 1) {
                params.value.startTime = powerOnList.value[powerOnIndex.value].start_time;
                params.value.endTime = powerOnList.value[powerOnIndex.value].end_time;
              }
              if (tabIndexS.value === 2) {
                params.value.startTime = "".concat(dayjs().format('YYYY-MM-DD'), " 00:00:00");
                params.value.endTime = "".concat(dayjs().format('YYYY-MM-DD'), " 23:59:59");
                params.value.type = 0;
              }
              isShowComponent.value = false;
              _context2.next = 7;
              return nextTick();
            case 7:
              isShowComponent.value = true;
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function confirmTypeS(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    var _useFeedingPowerOn = useFeedingPowerOn(),
      _useFeedingPowerOn2 = _slicedToArray(_useFeedingPowerOn, 2),
      powerOnList = _useFeedingPowerOn2[0],
      getFeedingPowerOnAsync = _useFeedingPowerOn2[1];
    // 开关机
    var powerOnIndex = ref(0);
    var powerOnTime = computed(function () {
      return powerOnList.value[powerOnIndex.value]['showTime'];
    });
    var preClickPowerOn = function preClickPowerOn() {
      if (powerOnIndex.value == powerOnList.value.length) {
        showToast('前面没有了...');
        return;
      }
      powerOnIndex.value++;
      handlePowerOnSelect(powerOnList.value[powerOnIndex.value], powerOnIndex.value);
    };
    var nextClickPowerOn = function nextClickPowerOn() {
      if (powerOnIndex.value == 0) {
        showToast('后面没有了...');
        return;
      }
      powerOnIndex.value--;
      handlePowerOnSelect(powerOnList.value[powerOnIndex.value], powerOnIndex.value);
    };
    var showPowerOnPopover = ref(false);
    var powerOnActions = computed(function () {
      return powerOnList.value;
    });
    var handlePowerOnSelect = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(data, index) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              powerOnIndex.value = index;
              params.value.startTime = data.start_time;
              params.value.endTime = data.end_time;
              isShowComponent.value = false;
              _context3.next = 6;
              return nextTick();
            case 6:
              isShowComponent.value = true;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function handlePowerOnSelect(_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }();
    // 自然日
    var dateRef = ref();
    var confirmTypeT = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(val) {
        var _dateRef$value;
        var date, timeData;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              params.value.type = val;
              //把所以日期控件的日期变为当前最新日期
              (_dateRef$value = dateRef.value) === null || _dateRef$value === void 0 || _dateRef$value.reset();
              date = '';
              if (val === 3) {
                date = "".concat(dayjs().format('YYYY/MM/DD'), " 00:00:00,").concat(dayjs().format('YYYY/MM/DD HH:mm:ss'));
              } else {
                date = dayjs().format('YYYY/MM/DD');
              }
              timeData = getTimeRange(params.value.type, date);
              params.value.startTime = timeData.startTime;
              params.value.endTime = timeData.endTime;
              isShowComponent.value = false;
              _context4.next = 10;
              return nextTick();
            case 10:
              isShowComponent.value = true;
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function confirmTypeT(_x5) {
        return _ref4.apply(this, arguments);
      };
    }();
    var confrimDate = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(val) {
        var timeData;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              timeData = getTimeRange(params.value.type, val);
              params.value.startTime = timeData.startTime;
              params.value.endTime = timeData.endTime;
              isShowComponent.value = false;
              _context5.next = 6;
              return nextTick();
            case 6:
              isShowComponent.value = true;
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function confrimDate(_x6) {
        return _ref5.apply(this, arguments);
      };
    }();
    var isShowComponent = ref(true);
    var componentArray = ref(['ReportForm', 'TableForm']);
    var curTabComponent = computed(function () {
      return componentArray.value[tabIndexF.value];
    });
    var router = useRouter();
    var toFeedingData = function toFeedingData() {
      router.push({
        path: 'FeedingData'
      });
    };
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            getFeedingHandoverAsync();
            getFeedingPowerOnAsync();
            isShowComponent.value = false;
            _context6.next = 5;
            return nextTick();
          case 5:
            isShowComponent.value = true;
          case 6:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    })));
    return {
      dateRef: dateRef,
      confirmTypeF: confirmTypeF,
      tabIndexF: tabIndexF,
      confirmTypeS: confirmTypeS,
      tabIndexS: tabIndexS,
      handoverTime: handoverTime,
      confirmTypeT: confirmTypeT,
      powerOnTime: powerOnTime,
      preClickPowerOn: preClickPowerOn,
      nextClickPowerOn: nextClickPowerOn,
      params: params,
      confrimDate: confrimDate,
      isShowComponent: isShowComponent,
      curTabComponent: curTabComponent,
      toFeedingData: toFeedingData,
      showPowerOnPopover: showPowerOnPopover,
      powerOnActions: powerOnActions,
      handlePowerOnSelect: handlePowerOnSelect
    };
  }
});